import app from '@/app';
import templateUrl from './save-item-button-bar.html';

var component = {
	templateUrl,
	require: {
		form: '^form'
	},
	bindings: {
		soft: '<',
		disabled: '<',
		readonly: '<',
		onAccept: '&',
		onReject: '&'
	}
};

app.component('prSaveItemButtonBar', component);
